import { render, staticRenderFns } from "./shop-distribution.vue?vue&type=template&id=68111e6c&scoped=true"
import script from "./shop-distribution.vue?vue&type=script&lang=ts"
export * from "./shop-distribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68111e6c",
  null
  
)

export default component.exports